import { fetch } from 'wix-fetch';
import wixLocation from 'wix-location';
export function sent_click(event) {
    let channelId = "23609";
	let channelKey = "58ce6e3402";
	let thankyoupage = "https://www.ppc-simple.co.il/thank-you";

	let crmApiURL = 'https://proxy.leadim.xyz/apiproxy/global/submit.cors.ashx?lm_redirect=no&lm_form=' + channelId + '&lm_key=' + channelKey;
	let postData = '';
         postData += 'name='+$w("#name").value;
	     postData += '&email='+$w("#email").value;
         postData += '&phone='+$w("#phone").value;
		 postData += '&Details='+$w("#Details").value;
		 		
	postData += '&lm_source='+ wixLocation.url;
	fetch(crmApiURL, {method: "POST", mode: "no-cors", headers: {"Content-Type":"application/x-www-form-urlencoded"}, body: postData})
	.then((fetchResult) => {wixLocation.to(thankyoupage)});
}



